import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './assets/css/tailwind.css'

// Crear instancia de Pinia
const pinia = createPinia()

// Crear y configurar aplicación
const app = createApp(App)

app.use(pinia)
app.use(router)

// Montar aplicación
app.mount('#app')